import React, { Component } from "react";
import { withStyles, styled } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Grid, TextField, Snackbar } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import  Modal  from "@mui/material/Modal";
import { Table, DatePicker, Button, Input, Select, Tabs, Modal as antModal, message  } from 'antd';
import { CloseOutlined, DeleteOutlined, SearchOutlined } from '@ant-design/icons'
import FlowModal from "../common/FlowModal";
import { 
  getLawDetail,
  getStandardList,
  getInstructionList,
  editLawDetailLabels
} from '../../actions/subscribe'

const { TabPane } = Tabs;
const { RangePicker } = DatePicker;
const { Option } = Select;


const styles = () => {
  return {
    root: {
      width: "100%",
    },
    search: {
      width: "100%",
      height: "61px",
      padding: "18px 24px",
      flexFlow: "column",
      background: "#fff",
    },
    line: {
      height: "25px",
      fontSize: "14px",
      color: "#000",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    },
    title: {
      marginRight: "10px",
      fontSize: "18px",
      fontWeight: "bold",
      color: "#5F6876",
    },
    btn: {
      width: "70px",
      height: "40px",
      background: "#3276C3",
      borderRadius: "0 !important",
    },
    container: {
    },
    tabBox: {
      height: "40px",
      "& .ant-tabs-nav": {
        marginBottom: "0 !important",
      },
      "& .ant-tabs-content-holder": {
        height: "0 !important",
      },
      "& .ant-tabs-tab-btn": {
        fontSize: "16px !important",
        fontWeight: "bold",
      },
    },
    tabContainer: {
      flex: "1",
      width: "100%",
      height: "1px",
      padding: "12px",
      background: "#fff",
      overflow: "hidden",
      boxShadow: "0 0 30px 10px rgba(0, 0, 0, .05)",
    },
    dateFilter: {
      width: "236px",
      padding: "8px",
    },
    defaultFilter: {
      width: "196px",
      padding: "8px",
    },
    btnLine: {
      marginTop: "8px",
      display: 'flex',
      justifyContent: 'space-between'
    },
    select: {
      width: '100%'
    },
    tableContainer: {
      width: '100%',
      '& .ant-table-cell-row-hover': {
        background: '#f0fbff !important'
      },
      '& td.ant-table-column-sort': {
        background: '#f0fbff !important'
      }
    },
    btn: {
      cursor: 'pointer',
      '&.del': {
        marginLeft: '10px',
        color: '#f00'
      },
    }
  };
};

class Inheritance extends Component {
  constructor(props){
    super(props);
  }

  state = {
    loading: true,
    filteredInfo: null,
    flowModal: false,
    medical_file: {},
    tabIndex: 0,
    filterForm: {},
    filterDropdownVisible: false,
    companyArr: [], // 申请人下拉数据
    dataSourceArr: [], // 数据来源下拉数据
    columns: [],
    data: [],
    updateTime: '',
    searchHistoryList: [],
    form: {},
    defaultForm: { // 默认值
      lable: "",
      medical_file__base_file__file_name__icontains: "",
      medical_file__medical_file_admin_location__icontains: "",
      medical_file_expired_date: [],
      medical_file_force_date: [],
      medical_file__medical_file_law_status: "",
      medical_file_publish_date: [],
      medical_file__medical_file_publish_orgnization: "",
      regulation_file_isbn: "",
      regulation_file_type: "",
    },
    labelObj: { // 筛选项key - label对应关系
      lable: '直观复星标签',
      medical_file__base_file__file_name__icontains: '文件名',
      medical_file__medical_file_admin_location__icontains: '管辖区域',
      medical_file_expired_date: '失效时间',
      medical_file_force_date: '生效时间',
      medical_file__medical_file_law_status: '立法阶段',
      medical_file_publish_date: '发布时间',
      medical_file__medical_file_publish_orgnization: '发布机构',
      regulation_file_isbn: '发文号',
      regulation_file_type: '法规类型',
    },
    labelListObj: { },
    selectKeys: [],
    sortObj: {},
    apiType: '1', // 默认请求法规
    apiTypeName: '法规', // 默认请求法规
    dataType: [
      {
        ID: '1',
        Name: '法规'
      },
      {
        ID: '2',
        Name: '标准'
      },
      {
        ID: '3',
        Name: '指导原则'
      },
    ],
    page: {
      page: 1,
      pageSize: 10
    },
    total: 0,
    scrollObj: {
      x: 1600,
      y: 600
    },
    paginationObj: {
      showSizeChanger: true,
      allTotal: 0,
      total: 0,
      showTotal: (total, range) => {
        return '当前已筛选出【' + this.state.paginationObj.total + '】条'
      },
      onChange: (page, pageSize) => {
        this.pageChange(page, pageSize)
      },
    }
  };

  componentDidMount() {
    // // 计算表格高度
    // let height = document.querySelector('#lawDetailTableContanier').offsetHeight
    // this.setState({
    //   scrollObj: {
    //     x: 1700,
    //     y: height - 200
    //   }
    // })

    let date = new Date()
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    let today = `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`
    this.setState({
      updateTime: today
    })

    this.initData()
  }

  resetForm = () => {
    this.setState({
      form: {
        KeyWord: "",
        companyName: "",
        variety: "",
        province: "",
        category: "",
        content: "",
      }
    })
  }

  clearHistory = () => {
    this.resetForm()
    this.setState({
      searchHistoryList: []
    }, () => this.initData())
  }

  removeSearchItem = (data, i) => {
    let form = {
      ...this.state.form
    }
    let list = [].concat(this.state.searchHistoryList)
    form[data.key] = this.state.defaultForm[data.key]
    list.splice(i, 1)
    this.setState({
      form: form,
      searchHistoryList: list
    }, () => this.initData())
  }

  searchForm = () => {
    this.initData()
    // 添加历史搜索记录
    let form = {
      ...this.state.form
    }
    let list = [].concat(this.state.searchHistoryList)
    for (let key in form) {
      let index = list.findIndex(v => {
        return v.key == key
      })
      if (form[key] && form[key].length > 0) {
        let showValue = form[key]
        let label = ''
        if (key == 'medical_file_expired_date' || key == 'medical_file_force_date' || key == 'medical_file_publish_date') {
          showValue = `${showValue[0].format("YYYY-MM-DD")} - ${showValue[1].format("YYYY-MM-DD")}`
        }
        if (this.state.selectKeys.indexOf(key) > -1) {
          label = this.state[this.state.labelListObj[key]].find(v => {
            return v.ID == showValue
          }).Name
        }
        if (index === -1) {
          let param = {
            label: this.state.labelObj[key],
            value: label || showValue,
            key: key
          } 
          list.push(param)
        } else {
          let itemIndex = list.findIndex(v => {
            return v.key == key
          })
          list[itemIndex].value = label || showValue
        }
      } else {
        if (index > -1) {
          list.splice(index, 1)
        }
      }
    }
    this.setState({
      searchHistoryList: list
    })
  }

  onChangeForm = (value, key) => {
    let form = {
      ...this.state.form
    }
    form[key] = value
    this.setState({
      form: form
    })
  }

  initData = async () => {
    let param =  Object.assign({}, this.state.form, this.state.page)

    let medical_file_expired_date = this.state.form.medical_file_expired_date
    let medical_file_force_date = this.state.form.medical_file_force_date
    let medical_file_publish_date = this.state.form.medical_file_publish_date

    if (medical_file_expired_date && medical_file_expired_date.length > 0) {
      param.medical_file__medical_file_expired_date__gte = medical_file_expired_date[0].format("YYYY-MM-DD")
      param.medical_file__medical_file_expired_date__lte = medical_file_expired_date[1].format("YYYY-MM-DD")
    }
    if (medical_file_force_date && medical_file_force_date.length > 0) {
      param.medical_file__medical_file_force_date__gte = medical_file_force_date[0].format("YYYY-MM-DD")
      param.medical_file__medical_file_force_date__lte = medical_file_force_date[1].format("YYYY-MM-DD")
    }
    if (medical_file_publish_date && medical_file_publish_date.length > 0) {
      param.medical_file__medical_file_publish_date__gte = medical_file_publish_date[0].format("YYYY-MM-DD")
      param.medical_file__medical_file_publish_date__lte = medical_file_publish_date[1].format("YYYY-MM-DD")
    }
    
    delete(param.medical_file_expired_date)
    delete(param.medical_file_force_date)
    delete(param.medical_file_force_date)
    
    let data = ''
    if (this.state.apiType == 1) {
      data = await getLawDetail(param)
    } else if (this.state.apiType == 2) {
      data = await getStandardList(param)
    } else if (this.state.apiType == 3) {
      data = await getInstructionList(param)
    }
    if (data && data.results) {
      let newPaginationObj = this.state.paginationObj
      newPaginationObj.total = data.count
      this.setState({
        data: data.results.map(v => {
          v.key = v.id
          return v
        }),
        paginationObj: newPaginationObj,
        loading: false
      }, () => {
        this.getColumns()
      })
    } else {
      this.setState({
        loading: false
      })
    }
  }

  initParam = () => {
    
  }

  getColumns = () => {
    let classes = this.props.classes

    let columns = [
      
      {
        title: '直观复星标签',
        dataIndex: 'lables',
        width: 160,
        key: 'lable',
      },
      {
        title: '文件名',
        dataIndex: 'file_name',
        key: 'medical_file__base_file__file_name__icontains',
        width: 300,
        render: (_, record) => (
          <a href={record.dfs_url} target="_blank">{record.file_name}</a>
        )
      },
      {
        title: '文件类型',
        dataIndex: 'file_category',
        width: 140,
        key: 'file_category',
      },
      {
        title: '管辖区域',
        dataIndex: 'medical_file_admin_location',
        key: 'medical_file__medical_file_admin_location__icontains',
        width: 140,
      },
      {
        title: '失效时间',
        dataIndex: 'medical_file_expired_date',
        width: 160,
        key: 'medical_file_expired_date',
        render: (_, record) => {
          return record.medical_file_expired_date.substring(0, 10)
        }
      },
      {
        title: '生效时间',
        dataIndex: 'medical_file_force_date',
        key: 'medical_file_force_date',
        width: 160,
        render: (_, record) => {
          return record.medical_file_force_date.substring(0, 10)
        }
      },
      {
        title: '立法阶段',
        dataIndex: 'medical_file_law_status',
        key: 'medical_file__medical_file_law_status',
        width: 150,
      },
      {
        title: '发布时间',
        dataIndex: 'medical_file_publish_date',
        key: 'medical_file_publish_date',
        width: 160,
        render: (_, record) => {
          return record.medical_file_publish_date.substring(0, 10)
        }
      },
      {
        title: '发布机构',
        dataIndex: 'medical_file_publish_orgnization',
        key: 'medical_file__medical_file_publish_orgnization',
        width: 180,
      },
      {
        title: '发文号', 
        dataIndex: 'regulation_file_isbn',
        key: 'regulation_file_isbn',
        width: 240,
        render: (_, record) => {
          let name = ''
          switch(this.state.apiType) {
            case '1': name = record.regulation_file_isbn; break;
            case '2': name = record.standard_file_serial_number; break;
            case '3': name = record.instruction_file_isbn; break;
            default: break;
          }
          return name
        },
        // ...this.getInputFilterOption(this.state.apiType == 1 ? 'regulation_file_isbn__icontains' : (this.state.apiType == 2 ? 'standard_file_serial_number__icontains' : 'instruction_file_isbn__icontains'), '发布机构', classes),
      },
      {
        title: '法规类型', // standard_file_type
        dataIndex: 'regulation_file_type',
        key: 'regulation_file_type',
        width: 160,
        // ...this.getInputFilterOption(this.state.apiType == 1 ? 'regulation_file_type' : 'standard_file_type', '发布机构', classes),
        render: (_, record) => {
          let name = ''
          switch(this.state.apiType) {
            case '1': name = record.regulation_file_type; break;
            case '2': name = record.standard_file_type; break;
            case '3': name = '-'; break;
            default: break;
          }
          return name
        },
      },
      {
        title: '操作',
        type: 'action',
        width: 120,
        render: (_, record) => [
          <a className={classes.btn} onClick={() => this.handleEdit(record)}>修改</a>,
          <a className={[classes.btn, 'del'].join(' ')} onClick={() => this.handleRemove(record)}>删除</a>,
        ]
      }
    ]

    this.setState({
      columns: columns,
    })
  }

  handleRemove = (data) => {
    //
    antModal.confirm({
      title: '提示',
      content: '您确认将该条法规数据从直观复兴法规库中删除吗？',
      onOk: () => {
        editLawDetailLabels({
          base_file_id: data.base_file_id,
          lables: JSON.stringify([]),
          operation_type: '删除',
          lable_category_name: this.state.apiTypeName,
          lable_category_type: '直观复兴'
        }).then(res => {
          if (res.isOperateSuccess) {
            message.success('删除成功')
            this.initData()
          } else {
            message.error(res.message)
          }
        })

      }
    })
  }


  // 分类流程
  handleEdit = (data) => {
    this.setState({
      flowModal: true,
      medical_file: {
        ...data,
        base_file: {
          file_category: data.file_category,
          file_name: data.file_name,
          file_id: data.base_file_id,
        },
        zgfx_lables: data.lables.split(',').map(v => {
          return {
            lable_content: v
          }
        })
      }
    })
  }

  submitEdit = (data) => {
    let record = this.state.medical_file
    editLawDetailLabels({
      base_file_id: record.base_file_id,
      lables: JSON.stringify(data),
      operation_type: '修改',
      lable_category_name: this.state.apiTypeName,
      lable_category_type: '直观复兴'
    }).then(res => {
      if (res.isOperateSuccess) {
        message.success('修改成功')
        this.closeFlow()
        this.initData()
      } else {
        message.error(res.message)
      }
    })
  }

  closeFlow = () => {
    this.setState({
      flowModal: false
    })
  }

  handleChange = (pagination, filters, sorter) => {
    let sortKey = sorter.column ? sorter.column.title : ''
    let order = sorter.order
    let sortObj = {
      SortCriteria: order ? sortKey : '',
      SortCriteriaMode: order == 'descend' ? 'Desc' : (order == 'ascend' ? 'Asc' : '')
    }
    this.setState({
      filteredInfo: filters,
      sortObj: sortObj,
      loading: true
    }, () => {
      this.getColumns()
      this.initData()
    });
  };

  handleSort = () => {}

  clearFilters = () => {
    this.setState({ filteredInfo: null });
  };

  clearAll = () => {
    this.setState({
      filteredInfo: null,
      apiType: '1',
      page: {
        page: 1,
        pageSize: 10
      },
      form: {},
      loading: true
    }, () => {
      this.getColumns()
      this.initData()
    });
  };


  handleReset = (clearFilters) => {
    clearFilters()
  }

  handleSearch = (key, value, confirm) => {
    let newForm = this.state.form
    newForm[key] = value
    this.setState({
      form: newForm,
      loading: true
    }, () => this.initData())
    confirm()
  }


  pageChange = (page, pageSize) => {
    if (page == this.state.page.page && pageSize == this.state.page.pageSize) {
      return
    }
    this.setState({
      page: {
        page: page,
        pageSize: pageSize
      },
      loading: true
    }, () => this.initData())
  }

  changeTab = (e) => {
    let name = this.state.dataType.filter(v => {
      return v.ID == e
    })[0].Name;
    this.setState(
      {
        apiType: e,
        apiTypeName: name,
        page: {
          page: 1,
          pageSize: 10
        },
        loading: true,
      },
      () => {
        this.getColumns();
        this.initData();
      }
    );
  };

  render() {
    const classes = this.props.classes;

    return (
      <div className="common-page">
        <div className="common-left-search">
          <div className="left-search-title">
            <span className="search-title">关键词搜索</span>
            
          </div>
          <div className="search-form">
            <div className="form-item">
              <div className="form-label">直观复星标签</div>
              <Input  value={this.state.form.lable}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'lable')} 
                placeholder="请输入直观复星标签"/>
            </div>
            <div className="form-item">
              <div className="form-label">文件名</div>
              <Input  value={this.state.form.medical_file__base_file__file_name__icontains}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'medical_file__base_file__file_name__icontains')} 
                placeholder="请输入文件名"/>
            </div>
            <div className="form-item">
              <div className="form-label">管辖区域</div>
              <Input  value={this.state.form.medical_file__medical_file_admin_location__icontains}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'medical_file__medical_file_admin_location__icontains')} 
                placeholder="请输入管辖区域"/>
            </div>
            <div className="form-item">
              <div className="form-label">失效时间</div>
              <RangePicker
                  value={this.state.form.medical_file_expired_date}
                  onChange={(value) => this.onChangeForm(value, 'medical_file_expired_date')}
                />
            </div>
            <div className="form-item">
              <div className="form-label">生效时间</div>
              <RangePicker
                  value={this.state.form.medical_file_force_date}
                  onChange={(value) => this.onChangeForm(value, 'medical_file_force_date')}
                />
            </div>
           
            <div className="form-item">
              <div className="form-label">立法阶段</div>
              <Input  value={this.state.form.medical_file__medical_file_law_status}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'medical_file__medical_file_law_status')} 
                placeholder="请输入立法阶段"/>
            </div>
            <div className="form-item">
              <div className="form-label">发布时间</div>
              <RangePicker
                  value={this.state.form.medical_file_publish_date}
                  onChange={(value) => this.onChangeForm(value, 'medical_file_publish_date')}
                />
            </div>
            <div className="form-item">
              <div className="form-label">发布机构</div>
              <Input  value={this.state.form.medical_file__medical_file_publish_orgnization}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'medical_file__medical_file_publish_orgnization')} 
                placeholder="请输入发布机构"/>
            </div>
            <div className="form-item">
              <div className="form-label">发文号</div>
              <Input  value={this.state.form.regulation_file_isbn}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'regulation_file_isbn')} 
                placeholder="请输入发文号"/>
            </div>
            <div className="form-item">
              <div className="form-label">法规类型</div>
              <Input  value={this.state.form.regulation_file_type}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'regulation_file_type')} 
                placeholder="请输入法规类型"/>
            </div>
            

          </div>

          <div className="search-bottom-btns">
            <Button className="default-btn" onClick={this.resetForm}>重置</Button>
            <Button className="primary-btn" onClick={this.searchForm}>搜索</Button>
          </div>
        </div>

        <div className="common-main">
          <div className="common-main-search">
            <div className="main-title">
              <div className="title-top">
                <div>
                  <span className="page-title">法规明细</span>
                  <span className="page-count">{this.state.paginationObj.total}条</span>
                </div>
                <span >数据更新至：{this.state.updateTime}</span>
              </div>
            </div>
            {
              this.state.searchHistoryList.length > 0 &&
              <div className="search-history">
                {
                  this.state.searchHistoryList.map((item, i) => (
                    <div className="history-item" key={i}>
                      <span>{item.label}：</span>
                      <span className="history-value">{item.value}</span>
                      <CloseOutlined className="clear-icon" onClick={() => this.removeSearchItem(item, i)}/>
                    </div>
                  ))
                }
                <div className="hitstory-btn" onClick={this.clearHistory}>
                  <DeleteOutlined className="btn-icon"/>
                  清空
                </div>
              </div>
            }
          </div>
          <div className="common-main-container">
            <div className="main-top">
              <div>
                {
                  this.state.dataType.map((v, i) => (
                    <span
                      onClick={() => this.changeTab(v.ID)}
                      className={[
                        "main-tab",
                        this.state.apiType == v.ID ? "active" : "",
                      ].join(" ")}
                    >
                      {v.Name}
                    </span>
                  ))
                }
              </div>
            </div>

            <Grid container className={classes.container} id="tableContainer">
              <Table 
                className={classes.tableContainer}
                columns={this.state.columns} 
                loading={this.state.loading} 
                dataSource={this.state.data} 
                onChange={this.handleChange} 
                pagination={this.state.paginationObj}
                scroll={this.state.scrollObj}
                bordered
                />
              
            </Grid>
          </div>
        </div>

        <Modal
          open={this.state.flowModal}
          onClose={this.closeFlow}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div>
            <FlowModal
              medical_file={this.state.medical_file}
              filterName={this.state.apiTypeName}
              close={this.closeFlow}
              isEdit={true}
              submitEdit={this.submitEdit}
            />
          </div>
        </Modal>
      </div>
    );
  }
}

export default withStyles(styles)(withRouter(Inheritance));
